export default [
  "Administrador",
  "Bodega",
  "Comercial",
  "Courier",
  "Jefe Comercial",
  "Enologia",
  "Calidad",
];
